export const REQUIRED_PREFIX_PUBLISHERS = ['SERIES', 'NAVER_WEBTOON']

export const ERROR_MESSAGES = {
  DEFAULT: '잠시 후 다시 시도해주세요.',
  MISSING_UID: 'uid 파라미터가 필요합니다.',
  API_ERROR: 'API 요청 중 에러가 발생했습니다.',
  PAGE_NOT_FOUND: '페이지를 찾을 수 없습니다.',
  INVALID_UID_PREFIX: '최신 버전으로 업데이트해 주셔야 문의가 가능 합니다.'
} as const

export const UID_PREFIX = '__idno__'
